import { Component, Inject, OnInit, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { filter, map } from 'rxjs/operators';
import { CombinacaoLista, FiltroCombinacao } from 'src/app/models/combinacao';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { ProdutoService } from 'src/app/services/produto.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';

@Component({
  selector: 'app-kits-sugeridos-modal',
  templateUrl: './kits-sugeridos-modal.component.html',
  styleUrls: ['./kits-sugeridos-modal.component.scss']
})
export class KitsSugeridosModalComponent implements OnInit, AfterViewInit {

  kits: CombinacaoLista[] = [];
  filtro = new FiltroCombinacao();
  mostrarValores = false;
  integrador = false;
  possuiMicroInversores = false;
  tipoInv = -1;
  buscarValorFinal = false;

  msgAlterarCD;
  bloquearSistema: boolean = false;
  administrador: boolean = false;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    public dialogRef: MatDialogRef<KitsSugeridosModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private pedidoService: PedidoService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private produtoService: ProdutoService,
    private utilitarioService: UtilitarioService,
    private premissasService: PremissasService,
    private globalService: GlobalService) {
    this.filtro.fase = data.fase;
    this.filtro.idPainel = data.idPainel;
    this.filtro.qtdPainel = data.qtdPainel;
    this.filtro.tensao = data.tensao;
    this.filtro.fileiras = data.fileiras !== null && data.fileiras !== undefined ? JSON.parse(JSON.stringify(data.fileiras)): data.fileiras;
    this.filtro.idMarca = data.idMarca;
    this.filtro.idFornecedorPainel = data.idFornecedorPainel;
    this.filtro.usarTransformador = data.usarTransformador;
    this.filtro.buscarMicroinversores = data.buscarMicroinversores;
    this.tipoInv = data.tipoInv;
    this.filtro.potenciaTotal = data.potSistema;
    this.filtro.idCliente = data.idCliente;
    this.msgAlterarCD = data.msgAlterarCD;
    this.buscarValorFinal = data.buscarValorFinal;
    this.filtro.descontoIndividual = data.descontoIndividual;
    this.filtro.percentual = data.percentual;
    this.filtro.valorDa = data.valorDa;
    this.filtro.ibge = data.ibge;
    this.filtro.uf = data.uf;
    this.filtro.incluirStringBox = data.incluirStringBox;
    this.filtro.tipoInv = this.tipoInv === -1 ? (this.filtro.fileiras !== undefined && this.filtro.fileiras !== null && this.filtro.fileiras.length > 0 ? this.filtro.fileiras[0].tipoInversor : 0) : this.tipoInv;
    this.filtro.idMarcaStringbox = data.marcaStringbox;
  }

  async ngOnInit() {
    this.integrador = await this.globalService.integrador();
    this.administrador = await this.globalService.administrador();
    await this.buscarVerPrecosProdutos();
    await this.buscarPossuiMicroInversorConfigurado();
    await this.buscarPremissasBloqueioSistema();
    this.buscarKits();
  }

  async buscarPremissasBloqueioSistema() {
    try {
      this.carregandoService.mostra('buscarBloqSist');
      this.bloquearSistema = await this.premissasService.consultarBloqSistManuProd().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarBloqSist');
    }
  }

  ngAfterViewInit(): void {

  }

  voltar() {
    this.dialogRef.close();
  }

  buscarKits() {
    if (this.tipoInv != -1 && this.tipoInv != null && this.tipoInv != undefined) {
      this.filtro.tipoInv = this.tipoInv;
    }

    if (this.filtro.fileiras !== null && this.filtro.fileiras !== undefined) {
      this.filtro.fileiras.forEach(p => {
        p.tipoInversor = this.filtro.tipoInv;
        p.microInversor = this.filtro.tipoInv === 1;
      });
    }

    this.carregandoService.mostra('buscarKitsSugeridos');
    this.pedidoService.buscarCombinacoes(this.filtro).subscribe(resp => {
      this.kits = resp;

      this.kits.forEach(kit => {
        kit.imagem$ = this.buscarImagemProduto(kit.idInversor);
        kit.imagem$.then(p => { kit.buscouImagem = true; });
      });

      this.carregandoService.esconde('buscarFornecedores');
      this.carregandoService.esconde('buscarKitsSugeridos');
    }, (erro) => {
      this.carregandoService.esconde('buscarKitsSugeridos');
      this.notificacaoService.erro(erro);
    });
  }

  async buscarImagemProduto(idProduto: number): Promise<string> {
    const imagem = await this.produtoService.consultarImagemProdutoPorId(idProduto).toPromise();

    if (imagem && imagem.url) {
      return Promise.resolve(imagem.url);
    } else if (imagem && imagem.raw) {
      return Promise.resolve('data:image/jpg;base64,' + imagem.raw);
    } else {
      return Promise.resolve('./assets/img/inversor.png');
    }
  }

  buscarKit(kit: CombinacaoLista) {
    this.carregandoService.mostra('buscarKit');
    this.filtro.idProduto = kit.idInversor;
    this.filtro.idAgrupamentoStringbox = kit.idAgrupamentoStringbox;
    this.pedidoService.buscarCombinacao(this.filtro).subscribe(resp => {
      kit.kitSelecionado = resp;
      this.carregandoService.esconde('buscarKit');
    }, (erro) => {
      this.carregandoService.esconde('buscarKit');

      const msgEspecial = this.parseErroEspecial(erro);
      this.notificacaoService.erro(msgEspecial || erro);
    });
  }

  private parseErroEspecial(erro: any): string | null {
    const msg: string = erro && erro.error ? erro.error : '';
    if (!msg || msg.charAt(0) !== '#') { return null; }

    const semHash = msg.substring(1);
    const partes = semHash.split('\n- ');
    const mensagemPrincipal = partes[0];
    const produtos = partes[1] ? partes[1].split('#') : [];

    // Retorna string HTML — showNotification já renderiza HTML
    let html = `<strong>${mensagemPrincipal}</strong>`;
    if (produtos.length) {
      html += '<br><ul style="margin:6px 0 0 16px;padding:0">'
        + produtos.map(p => `<li>${p.trim()}</li>`).join('')
        + '</ul>';
    }
    return html;
  }

  selecionar(itens) {
    this.dialogRef.close(itens);
  }

  async buscarVerPrecosProdutos() {
    try {
      this.carregandoService.mostra('buscarVerPrecosProdutos');
      this.mostrarValores = (await this.premissasService.consultarVerPrecoProdutos().toPromise()).valor;
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarVerPrecosProdutos');
    }
  }

  async buscarPossuiMicroInversorConfigurado() {
    try {
      this.carregandoService.mostra('buscarPossuiMicroInversorConfigurado');
      this.possuiMicroInversores = await this.produtoService.possuiMicroInversorConfigurado().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPossuiMicroInversorConfigurado');
    }
  }

}
